/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreTimesheetScopeResponseDto } from '../../models/core-timesheet-scope-response-dto';

export interface TimesheetScopesControllerFindOne$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Scope ID
 */
  id: string;
}

export function timesheetScopesControllerFindOne(http: HttpClient, rootUrl: string, params: TimesheetScopesControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, timesheetScopesControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>;
    })
  );
}

timesheetScopesControllerFindOne.PATH = '/o2-core/timesheet-scopes/{tenant}/{id}';
